import { z } from 'zod';
import { objectIdSchema } from '../common.js';
/**
 * Barcha hujjatlarda bo'ladigan maydonlar (docs/02-DATABASE.md §1).
 *
 * O'chirish — soft delete: `deletedAt`. Barcha public so'rovlarda
 * `deletedAt: null` filtri qo'yiladi.
 */
export const auditableSchema = z.object({
    _id: objectIdSchema,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
    createdBy: objectIdSchema.nullable().default(null),
    updatedBy: objectIdSchema.nullable().default(null),
    deletedAt: z.coerce.date().nullable().default(null),
});
/**
 * Eski saytlardan ko'chirilgan yozuvlar uchun (TZ 12).
 * 301 redirect jadvali va migratsiya idempotentligi shu maydonlarga tayanadi.
 */
export const legacySchema = z.object({
    legacySource: z.enum(['geoic', 'uzdron']).nullable().default(null),
    legacyId: z.number().int().nullable().default(null),
    legacyUrl: z.string().max(300).nullable().default(null),
});
/** Nashr holati. `editor` roli buni o'zgartira olmaydi (TZ 3.2). */
export const publishableSchema = z.object({
    isPublished: z.boolean().default(false),
    publishedAt: z.coerce.date().nullable().default(null),
});
export const orderableSchema = z.object({
    order: z.number().int().min(0).default(0),
});
/**
 * Sayt bo'ylab qidiruv uchun so'z boshlari (`/qidiruv`).
 *
 * Nega MASSIV, uzun satr emas: `{searchTokens: /^dron/}` — massiv (multikey)
 * indeksda IXSCAN bo'ladi va so'z boshi bo'yicha qidiruv indeksdan
 * foydalanadi. Uzun satrda esa `/dron/` boshiga bog'lanmagan regex bo'lib,
 * har safar butun kolleksiyani o'qirdi (docs/05-TESTING.md §4).
 *
 * `$text` indeksi ham ko'rib chiqilgan, lekin u faqat TO'LIQ so'zni
 * topadi: «dronlar» yozilganda «dron» topilmasdi.
 *
 * Maydon SERVER tomonda hisoblanadi (`BaseContentService`), kirish
 * sxemalarida yo'q va ommaviy javobga chiqmaydi.
 */
export const searchableSchema = z.object({
    searchTokens: z.array(z.string().max(60)).max(400).default([]),
});
/**
 * Avtosaqlash qoralamasi va tahrirlash qulfi (TZ 7.2 §7–9).
 *
 * Nega hujjatning O'ZIDA, alohida kolleksiyada emas: qoralama har doim
 * bitta hujjatga tegishli va u bilan birga o'chadi. Alohida kolleksiya
 * bo'lsa, har bir tahrirlash ekranida ikkinchi so'rov va yetim
 * qoralamalarni tozalaydigan ish kerak bo'lardi.
 *
 * `draft` — tekshirilmagan, TUGALLANMAGAN kirish. U saytga hech qachon
 * chiqmaydi: faqat admin va `?preview=` uni ko'radi.
 */
export const editableSchema = z.object({
    draft: z.record(z.string(), z.unknown()).nullable().default(null),
    draftAt: z.coerce.date().nullable().default(null),
    draftBy: objectIdSchema.nullable().default(null),
    /** Qulf `expiresAt` dan keyin o'z-o'zidan kuchini yo'qotadi. */
    editLock: z
        .object({
        userId: objectIdSchema,
        userName: z.string().max(200),
        expiresAt: z.coerce.date(),
    })
        .nullable()
        .default(null),
});
//# sourceMappingURL=base.js.map